import { render, staticRenderFns } from "./IdentityTheftReportDialog.vue?vue&type=template&id=55e6351e&"
import script from "./IdentityTheftReportDialog.vue?vue&type=script&lang=js&"
export * from "./IdentityTheftReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./IdentityTheftReportDialog.vue?vue&type=style&index=0&id=55e6351e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports